import React from "react";
import {
  FaBullseye,
  FaLock,
  FaMapMarkerAlt,
  FaRegClock,
} from "react-icons/fa";

const ITEMS = [
  {
    icon: FaMapMarkerAlt,
    title: "Recherche nationale",
    description:
      "Filtrez les annonces par région, département, grade ou kata.",
  },
  {
    icon: FaBullseye,
    title: "Objectifs précis",
    description:
      "Indiquez le kata travaillé, le rôle recherché et vos disponibilités.",
  },
  {
    icon: FaRegClock,
    title: "Annonces récentes",
    description:
      "Les annonces expirent automatiquement afin de conserver des résultats utiles.",
  },
  {
    icon: FaLock,
    title: "Gestion sécurisée",
    description:
      "La modification et la suppression sont protégées par email et mot de passe.",
  },
];

export default function KataStats() {
  return (
    <section className="relative z-10 mx-auto -mt-8 max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.12)] dark:border-white/10 dark:bg-slate-900 sm:grid-cols-2 xl:grid-cols-4">
        {ITEMS.map((item, index) => {
          const Icon = item.icon;

          return (
            <article
              key={item.title}
              className={[
                "p-6",
                index > 0
                  ? "border-t border-slate-200 dark:border-white/10 sm:border-l sm:border-t-0"
                  : "",
                index === 2
                  ? "sm:border-l-0 xl:border-l"
                  : "",
              ].join(" ")}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-100 text-xl text-orange-600 dark:bg-orange-500/10 dark:text-orange-300">
                <Icon />
              </span>

              <h2 className="mt-4 text-base font-semibold text-slate-950 dark:text-white">
                {item.title}
              </h2>

              <p className="mt-2 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
                {item.description}
              </p>
            </article>
          );
        })}
      </div>
    </section>
  );
}